/* eslint-disable max-len */
import React, { useCallback, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';

import {
  ModalForm,
  TextField,
  FormItemRow,
  Intl,
  FormActionsBtns,
  ConfirmationModal,
  Checkbox,
} from 'components';
import { composeValidators, email, required } from 'config/InputErrors';

export default ({
  data,
  isLoading,
  open,
  onSubmit,
  onClose,
  onUnsubscribeNumber,
}) => {
  const [unsubscribeModal, setUnsubscribeModal] = useState(false);
  const [show, setShow] = useState(true)

  const toggleUnsubscribeModal = useCallback(() => {
    setUnsubscribeModal((state) => !state);
    setShow((show) => !show);
  }, []);

  return (
    <>{show ?
      <ModalForm
        initialValues={data}
        open={open}
        isLoading={isLoading}
        showErrorsInHeader
        size="lg"
        onClose={onClose}
        onSubmit={onSubmit}
        footer={<FormActionsBtns saveLabel="save" onClickCancel={onClose} />}
        body={() => (
          <>
            <Col className="text-center mb-5">
              <Button
                color="app-default"
                size="app-sm"
                type="button"
                className="font-weight-700"
                onClick={toggleUnsubscribeModal}
              >
                <Intl id="unsubscribe" />
              </Button>
            </Col>
            <Col className="mb-3 text-center">
              <Intl id="uncheckForIncomingEmail" />
            </Col>
            <Row>
              <Col md={{ size: 3 }} className="pr-0">
                <Checkbox
                  field="isSendEmail"
                  labelStyle={{ fontSize: '13px' }}
                  translateLabel={false}
                  label={(
                    <span className="mt-1" style={{ fontSize: '11px', top: '4px' }}>
                      <Intl id="enableNotification" />
                    </span>
                  )}
                  divStyle={{marginLeft: 'auto'}}
                />
              </Col>
              <Col>
                <FormItemRow
                  title="email"
                  titleSize={4}
                  fieldSize={7}
                  field={(
                    <TextField
                      field="emailNotification"
                      formGroupClass="m-0"
                      validate={composeValidators(required, email)}
                    />
                  )}
                />
              </Col>
            </Row>

            {/* <Row className="mt-2">
              <Col>
                <Checkbox
                  field="isSendEmail"
                  labelStyle={{ fontSize: '13px' }}
                  translateLabel={false}
                  label={(
                    <span className="mt-1" style={{ fontSize: '11px', top: '4px' }}>
                      <Intl id="enableNotification" />
                    </span>
                  )}
                />
              </Col> */}
            {/* <Col md={{ size: 8 }} className="text-right">
              <Button
                color="app-default"
                size="app-sm"
                type="button"
                className="font-weight-700"
                onClick={toggleUnsubscribeModal }
              >
                <Intl id="unsubscribe" />
              </Button>
            </Col> */}
            {/* <Col className="text-sm">
              <Intl id="footNodeOnAdministration" />
            </Col> */}
            {/* </Row> */}
          </>
        )}
      />
      : null}
      <ConfirmationModal
        open={unsubscribeModal}
        title="unsubscribeNumberConfirmation"
        subtitle="unsubscribeNumberConfirmation.warning"
        onConfirm={() => onUnsubscribeNumber(toggleUnsubscribeModal)}
        onClose={toggleUnsubscribeModal}
      />
    </>
  );
};
